export enum AttributeValueOrdering {
    ORDERED_LIST = "ORDERED_LIST",
    UNORDERED_SET = "UNORDERED_SET"
}
